import { request } from "utils/axios";
import { getApiErrorMessage } from "utils/apiErrors";


export const order = async (value) => {
    try {
        const res = await request.post('orders', value);
        console.log(res?.data)
        return res?.data
    } catch (error) {
        console.log(getApiErrorMessage(error), "order request failed");
        throw error;
    }
};

export const orders = async (page = 1) => {
    try {
        const res = await request.get(`orders?page=${page}`);
        console.log(res?.data)
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings went wrong');
        throw error;
    }
};

export const getOrder = async (id) => {
    try {
        const res = await request.get(`orders/${id}`);
        console.log(res?.data)
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings went wrong');
        throw error;
    }
}

export const addDeliveryNote = async (value, id) => {
    try {
        const res = await request.put(`orders/${id}/notes`, value);
        console.log(res?.data)
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings went wrong');
        throw error;
    }
}

export const getPendingPrepaidOrders = async () => {
    const res = await request.get("get-pending-prepaid-orders");
    return res?.data;
};

export const getCompletedPrepaidOrders = async () => {
    const res = await request.get("get-completed-prepaid-orders");
    return res?.data;
};

export const getPrepaidOrderWithDetails = async (prepaidRef) => {
    const res = await request.get(`get-prepaid-order-with-details-web/${prepaidRef}`);
    return res?.data;
};

export const uploadProofOfPayment = async (prepaidRef, file) => {
    const form = new FormData();
    // backend may expect any of these keys; sending both is harmless
    form.append("file", file);
    form.append("proof", file);
    const res = await request.post(`upload-proof-of-payment-web/${prepaidRef}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res?.data;
};






